/** @jsx jsx */
import { gql } from '@apollo/client';
import { Label } from '@bottlebooks/gatsby-design-system';
import { Link } from '@bottlebooks/gatsby-theme-base';
import { graphql } from 'gatsby';
import { jsx } from 'theme-ui';

export default function ProductStand({
  stand,
  exhibitor,
  to,
  href,
  onClick,
  ...rest
}) {
  if (!stand && !exhibitor) return null;
  return (
    <Label {...rest}>
      <Link to={to} onClick={onClick} href={href}>
        {[stand && stand.titleWithPrefix, exhibitor && exhibitor.name]
          .filter(Boolean)
          .join(' — ')}
      </Link>
    </Label>
  );
}

export const fragment = graphql`
  fragment ProductStand on Product {
    producer {
      name
    }
    exhibitor {
      name
    }
    stand {
      titleWithPrefix: title(prefix: "Stand ")
    }
  }
`;

export const ProductStandFragment = gql`
  fragment ProductStand on Product {
    producer {
      name
    }
    ... on ExtendedProduct {
      exhibitor {
        name
      }
      stand {
        titleWithPrefix: name(prefix: "Stand ")
      }
    }
  }
`;
